import { createUseStyles } from 'react-jss'
import { colors } from 'components/common'

const useLineDividerStyles = createUseStyles({
  lineDivider: {
    margin: '2rem 0',
    borderTop: `1px solid ${colors.gray200}`
  },
  title: {
    marginRight: '1rem',
    color: colors.theme500,
    width: 'max-width'
  }
})

export { useLineDividerStyles }
